<template>
  <div class="teamRanking">
    <div class="box1">
      <span class="title">优秀战队</span>
      <select class="select">
        <option>总部</option>
        <option>分部</option>
        <option>中分部</option>
        <option>小分部</option>
      </select>
      <input class="date" type="date">
      <div class="bottomBox">
        <div class="img3">
          <img :src="backgroundImg" alt="" style="width: 100%; height: 100%;">
        </div>
        <div class="month">
          <div class="span_month">获奖月份</div>
          <div class="span_month2">2022.8.17</div>
        </div>
        <div class="personnel">
          <div class="span_personnel">获奖人员</div>
          <div class="span_month2">战队</div>
        </div>
      </div>
    </div>
    <div class="box2">
      <span class="title">优秀个人</span>
      <select class="select">
        <option>总部</option>
        <option>分部</option>
        <option>中分部</option>
        <option>小分部</option>
      </select>
      <input class="date" type="date">
      <div class="bottomBox">
        <div class="img3">
          <img :src="backgroundImg" alt="" style="width: 100%; height: 100%;">
        </div>
        <div class="month">
          <div class="span_month">获奖月份</div>
          <div class="span_month2">2022.8.17</div>
        </div>
        <div class="personnel">
          <div class="span_personnel">获奖人员</div>
          <div class="span_month2">战队</div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="top_tip">
        <span class="title">个人业绩排名</span>
        <select class="select">
          <option>总部</option>
          <option>分部</option>
          <option>中分部</option>
          <option>小分部</option>
        </select>
        <input class="personal_date" type="date">
      </div>
      <div class="ranking">
        <el-table
          :data="tableData"
          border
          height="220px"
          style="width: 100%">
          <el-table-column
            align="center"
            label="排名"
            prop="date"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="姓名"
            prop="date"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="成交额"
            prop="name"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "teamRanking",
  data() {
    return {
      backgroundImg: require('../../../../public/img/yxzd.jpg')
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.bottomBox {
  position: relative;
  //background-color: orange;
  margin-top: 50px;

  .month {
    position: absolute;
    top: -28px;
    left: 190px;
    float: left;
    height: 50%;
    margin-top: 50px;
    //text-align: center;
    //display: inline-block;
    .span_month2 {
      color: #2d8cf0;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .personnel {
    position: absolute;
    top: 116px;
    left: 190px;
    float: left;
    height: 50%;
    //display: inline-block;
    .span_month2 {
      color: #2d8cf0;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .img3 {
    float: left;
    width: 134px;
    height: 201px;
    margin-left: 30px;
  }

  .span_month {

  }

  .span_personnel {

  }

}

.teamRanking {
  width: 1648px;
  height: 300px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;

  .box1 {
    position: relative;
    float: left;
    width: 22%;
    height: 300px;
    margin-right: 40px;
    background-color: rgba(255, 255, 255, 0.5);

    .select {
      position: absolute;
      top: 12px;
      right: 120px;
      width: 90px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .date {
      position: absolute;
      top: 12px;
      right: 18px;
      width: 90px;
      height: 20px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .title {
      position: absolute;
      top: 12px;
      left: 20px;
      font-weight: 600;
      width: 140px;
    }
  }

  .box2 {
    position: relative;
    float: left;
    width: 22%;
    height: 300px;
    margin-right: 57px;
    background-color: rgba(255, 255, 255, 0.5);

    .select {
      position: absolute;
      top: 12px;
      right: 120px;
      width: 90px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .date {
      position: absolute;
      top: 12px;
      right: 18px;
      width: 90px;
      height: 20px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .title {
      position: absolute;
      top: 12px;
      left: 20px;
      font-weight: 600;
      width: 140px;
    }
  }

  .box3 {
    float: left;
    width: 49%;
    height: 300px;
    background-color: rgba(255, 255, 255, 0.5);

    .top_tip {
      position: relative;
      height: 30px;

      .select {
        position: absolute;
        top: 12px;
        right: 120px;
        width: 90px;
        border: 1px solid #cecece;
        border-radius: 3px;
      }

      .personal_date {
        position: absolute;
        top: 12px;
        right: 18px;
        width: 90px;
        height: 19px;
        border: 1px solid #cecece;
        border-radius: 3px;
      }

      .title {
        position: absolute;
        top: 12px;
        left: 20px;
        font-weight: 600;
        width: 140px;
      }
    }

    .ranking {
      margin-top: 30px;
      margin-left: 14px;
    }
  }

}

</style>
